import {IHeroFilterTab} from "@/lib/types/common/IHeroFilterTab";
import {FilterTabsEnum} from "@/lib/enums/FilterTabsEnum";
import {Icon} from "@/app/components/common/Icon";

export const FILTER_TABS: IHeroFilterTab[] = [
    {
        value: FilterTabsEnum.LOBBY,
        label: 'FilterTabs.lobby',
        icon: <Icon name={'home'} />,
    },
    {
        value: FilterTabsEnum.SLOTS,
        label: 'FilterTabs.slots',
        icon: <Icon name={'slots'} />,
    },
    {
        value: FilterTabsEnum.LIVE_CASINO,
        label: 'FilterTabs.liveCasino',
        icon: <Icon name={'liveCasino'} />,
    },
    {
        value: FilterTabsEnum.TABLE_GAMES,
        label: 'FilterTabs.tableGames',
        icon: <Icon name={'tableGames'} />,
    },
    {
        value: FilterTabsEnum.POPULAR,
        label: 'FilterTabs.popular',
        icon: <Icon name={'popular'} />,
    }
]
